<template>
  <div class="integration-card box flex">
    <!-- <el-card class="cursor-pointer integration-card-shadow" style="text-align: center;">
      <span class="card_header display-block">
        <i :class="iconClass" v-if=".iconClass"></i>
        <span style="font-size: 1.5em;" v-else>{{ title }}</span>
      </span>
      <div v-if="hasCardBodySlot" class="card_body text-underline cursor-pointer">
        <slot name="card_body"></slot>
      </div>
      <div v-else class="card_body text-underline cursor-pointer" :class="{ hidden: !accounts || !accounts.length }">
        <router-link v-if="routeLink" :to="{ name: routeLink.name, query: routeLink.query, params: routeLink.param }">
          <a>{{ accounts.length }} Accounts</a>
        </router-link>
      </div>
      <div class="card_footer center">
        <el-button v-if="buttonText" class="uppercase less-padding" size="small" round @click.native="addClick">
          {{ buttonText }}
        </el-button>
        <el-button v-else class="uppercase" size="small" round @click.native="addClick">add</el-button>
      </div>
    </el-card> -->

    <el-card class="cursor-pointer" style="border: none; box-shadow: none;">
      <div style="display: flex;">
        <div :style="[iconClass.includes('logo-confluera') ? darkBckg : transparenBckg]" class="card-logo-container">
          <i :class="iconClass" v-if="iconClass"></i>
          <span style="font-size: 1.5em;" v-else>{{ title }}</span>
        </div>
        <div class="mt-4">
          <div
            v-if="hasCardHeaderSlot"
            :class="{ 'text-uppercase': !(iconClass.includes('logo-slack-color') || iconClass.includes('logo-team') || iconClass.includes('logo-jira-color')) }"
            class="card-header-container"
          >
            <slot name="card_header"></slot>
          </div>
          <div class="card-footer-container">
            <div v-if="hasCardFooterSlot">
              <slot name="card_footer"></slot>
            </div>
            <div v-else>
              <router-link
                v-if="accounts.length && routeLink"
                :to="{ name: routeLink.name, query: routeLink.query, params: routeLink.param }"
                class="remove-underline"
                @click.native.stop.prevent
              >
                <a class="remove-underline" style="color: #fab71a; font-size: 14px;">{{ accounts.length }} Accounts</a>
              </router-link>
              <span class="deactive-link" @click.stop v-else> {{ accounts.length }} Accounts </span>
            </div>
            <div>
              <el-button
                v-if="buttonText"
                class="text-btn less-padding"
                @click.native.stop="$allow('network', 'write') && addClick()"
                :class="{'disabled': !$allow('network', 'write')}"
              >
                {{ buttonText }}
              </el-button>
              <el-button
                v-else
                type="text"
                @click.native.stop="$allow('network', 'write') && addClick()"
                class="text-btn"
                :class="{'disabled': !$allow('network', 'write')}"
              >
                Add
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'IntegrationCard',
  props: {
    iconClass: { type: String },
    title: { type: String },
    buttonText: { type: String },
    routeLink: { type: Object },
    accounts: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      darkBckg: {
        backgroundColor: '#101F31'
      },
      transparenBckg: {
        backgroundColor: 'transparent'
      }
    }
  },
  mounted () {},
  methods: {
    addClick () {
      this.$emit('add-click')
    }
  },
  computed: {
    hasCardHeaderSlot () {
      return this.$slots['card_header']
    },
    hasCardFooterSlot () {
      return this.$slots['card_footer']
    }
  },
  components: {}
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
.integration-card {
  margin: auto;
  height: 100%;
}

.card_header {
  height: 70%;
}

.card_body {
  height: 15%;
}

.card_footer {
  height: 15%;
  width: calc(100% - 40px);
  min-width: 90px;
  margin-top: 40px;

  &.center {
    text-align: center;
    margin: auto;
    padding-top: 10px;
  }

  .el-button.less-padding {
    padding: 5px 20px;
  }
}

>>> .el-card {
  width: 100%;
}

.hidden {
  visibility: hidden;
}

.el-button {
  color: white;
  background-color: var(--aluminum-800);
  padding: 5px 30px;
}

.integration-card-shadow {
  box-shadow: 2px 2px 6px 0px rgb(0 0 0 / 40%), 2px 2px 6px 0px rgb(0 0 0 / 0%);
}

.integration-card-shadow:hover {
  border: 1px solid black;
  box-shadow: 5px 10px 8px 2px rgb(0 0 0 / 32%), 0px 0px 11px 1px rgb(0 0 0 / 32%);
}

.integration-icon {
  display: block;
  margin: 20px auto;
  mask-size: cover;
  mask-repeat: no-repeat;
  mask-size: 8em;
  width: 120px;
  height: 45px;
}

.logo-confluera {
  margin: 15px auto;
}

.logo-kubernetes-color {
  margin: 13px auto;
}

.logo-trendmicro-color {
  margin: 16px auto;
}

.logo-slack-color {
  margin: 17px 34px;
}

.logo-jira-color {
  margin-left:38px;
  margin-top:17px;
}

.logo-devo-color {
  margin-top:30px;
}

.logo-aws-rds-color {
  margin-top: 15px;
  margin-left: 37px;
  width: 44px !important;
  height: 50px !important;
}

.logo-wef-color {
  margin-top:17px;
}

.card-logo-container {
  margin-right: 25px;
  box-sizing: border-box;
  height: 80px;
  width: 120px;
  border: 1px solid #6c7182;
  border-radius: 8px;
}

.card-header-container {
  height: 24px;
  width: 175px;
  color: #000000;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 24px;
}

.card-footer-container {
  height: 40px;
  width: 74px;
  color: #1a90fa;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 20px;
}

.remove-underline {
  text-decoration: none;
}

.deactive-link {
  color: #d2d2d2;
}

.text-button {
  background: none;
  color: #1a90fa;
  padding-left: 0px;
  width: 0px;
  border: none;
}

.text-btn {
  background: none;
  color: #1A90FA;
  padding-left: 0px;
  width: 0px;
  border: none;
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
  color: #d2d2d2;
}

</style>



// WEBPACK FOOTER //
// src/components/card/integration/IntegrationCard.vue